import { createAction } from "@reduxjs/toolkit";

const addCategoriesListAsyncAction = createAction("ADD_CATEGORIES_LIST_ASYNC");
export const addLinesListAsyncAction = createAction("ADD_LINES_LIST_ASYNC");
export const addProductsListAsyncAction = createAction(
  "ADD_PRODUCTS_LIST_ASYNC"
);

export default addCategoriesListAsyncAction;
